import { useEffect, useState } from 'react';
import { isArray } from 'lodash';
import { appIcon } from 'src/assets';
import { IPanoAppartments } from 'src/containers/MainPageApartmentsV2/hooks';
import { pictureRegExp } from 'src/constants';
import { RandomInteger } from 'src/helpers/randomInteger';
import { IPlacement, IPlacementFields } from 'src/typings/placement';
import { useAppMediaQuery } from 'src/hooks/app/useAppMediaQuery';
import {
  ApplicationPropertyType,
  ApplicationPropertyTypeEnum,
  IGalleryListOfSpinner,
  ReactImageGalleryItemWithSpinnerData,
  SpinnerLabel,
} from '../types';

export const useGenerateGalleryFormat = (
  spinnerApartments: IGalleryListOfSpinner[] | [],
  panoApartments: IPanoAppartments[],
  placement: IPlacement,
  combineIds: string[],
) => {
  const { isMdDown } = useAppMediaQuery();
  const [galleryState, setGalleryState] = useState<ReactImageGalleryItemWithSpinnerData[]>([]);
  const [onlySliderState, setOnlySliderState] = useState<ReactImageGalleryItemWithSpinnerData[]>([]);
  const [onlySpinnerState, setOnlySpinnerState] = useState<ReactImageGalleryItemWithSpinnerData[]>([]);
  const [onlyRoomTourState, setOnlyRoomTourState] = useState<ReactImageGalleryItemWithSpinnerData[]>([]);
  const [onlyIframesState, setOnlyIframesState] = useState<ReactImageGalleryItemWithSpinnerData[]>([]);
  const pictureRegex = new RegExp(pictureRegExp);

  useEffect(() => {
    const urls = placement[IPlacementFields.urls];
    if ((!spinnerApartments || !spinnerApartments.length) && (!panoApartments || !panoApartments.length)) {
      const arr = urls?.gallery.map((image) => {
        return {
          id: RandomInteger(),
          viewType: SpinnerLabel.apartment,
          original: image,
          thumbnail: image,
          originalClass: 'apartment-gallery-v2-slide-item',
          thumbnailClass: 'apartment-gallery-v2-thumbnail',
          appProperty: ApplicationPropertyTypeEnum.gallery,
        };
      }) || [];
      setGalleryState(arr);
      setOnlySliderState(arr);
    } else {
      // const panoState = panoApartments.reduce((acc: ReactImageGalleryItemWithSpinnerData[], cur: IPanoAppartments) => {
      //   return [
      //     ...acc,
      //     {
      //       original: 'panorama',
      //       thumbnail: appIcon.icon360,
      //       originalClass: 'apartment-gallery-v2-spinner',
      //       thumbnailClass: 'apartment-gallery-v2-thumbnail-spinner',
      //       ...cur,
      //     },
      //   ];
      // }, [] as ReactImageGalleryItemWithSpinnerData[]);
      // @ts-ignore
      const initialSpinnerState = spinnerApartments.reduce((acc: any, cur: IGalleryListOfSpinner) => {
        const findedPoly = cur.data.additional_data.spinner_svg
        && Object.keys(cur.data.additional_data.spinner_svg).reduce((accPoly: boolean, stopId: string) => {
          if (cur.data && isArray(cur.data.additional_data.spinner_svg[stopId])) {
            const finded = cur.data.additional_data.spinner_svg[stopId].find((svg: any) => {
              return combineIds.includes(svg.attr['entity-view-name-id']);
            });
            if (finded) return true;
          }
          return accPoly;
        }, false);

        if (!findedPoly) return acc;

        const spinnerData = {
          id: RandomInteger(),
          viewType: SpinnerLabel.spinner,
          original: SpinnerLabel.spinner,
          thumbnail: appIcon.icon360.default,
          originalClass: 'apartment-gallery-v2-spinner',
          thumbnailClass: 'apartment-gallery-v2-thumbnail-spinner',
          spinnerData: cur.data,
          icon: cur.icon,
          order: cur.order,
          type: cur.name,
          appProperty: ApplicationPropertyTypeEnum.building,
        };
        setOnlySpinnerState([...acc, spinnerData]);
        return [
          ...acc,
          spinnerData,
        ];
      }, [] as ReactImageGalleryItemWithSpinnerData[]);

      const slides = urls?.gallery.reduce((acc, cur, currentIndex) => {
        const slide: ReactImageGalleryItemWithSpinnerData = {
          id: RandomInteger(),
          viewType: SpinnerLabel.apartment,
          original: isMdDown ? cur.replace('desktop', 'mobile') : cur,
          thumbnail: isMdDown ? cur.replace('desktop', 'mobile') : cur,
          originalClass: 'apartment-gallery-v2-slide-item',
          thumbnailClass: 'apartment-gallery-v2-thumbnail',
          order: currentIndex,
          appProperty: ApplicationPropertyTypeEnum.roomsTour,
        };
        if (pictureRegex.test(cur)) {
          setOnlySliderState([...acc, slide]);
        } else {
          slide.viewType = SpinnerLabel.tour;
          setOnlyRoomTourState([slide]);
        }
        return [
          ...acc,
          slide,
        ];
      }, [] as ReactImageGalleryItemWithSpinnerData[]) || [];
      if (urls) {
        const iframeButtons = {
          [IPlacementFields.button4]: urls['app.button4'],
          [IPlacementFields.button5]: urls['app.button5'],
          [IPlacementFields.button6]: urls['app.button6'],
        };
        const iframeButtonsState = Object.keys(iframeButtons)
          // @ts-ignore
          .filter((btnKey) => Object.keys(placement[IPlacementFields.urls]).includes(btnKey) && placement[IPlacementFields.urls][btnKey])
          .map((btnKey, index) => {
            // @ts-ignore
            const value = placement[IPlacementFields.urls][btnKey];
            return {
              id: RandomInteger(),
              viewType: SpinnerLabel.iframe,
              original: value,
              originalTitle: btnKey,
              originalClass: 'apartment-gallery-v2-slide-item',
              thumbnailClass: 'apartment-gallery-v2-thumbnail',
              order: index,
              appProperty: btnKey as ApplicationPropertyType,
            };
          });
        setOnlyIframesState(iframeButtonsState);
      }

      setGalleryState(initialSpinnerState.concat(slides).sort((a: any, b: any) => a.order - b.order));
    }
  }, [spinnerApartments, placement]);

  return {
    galleryState,
    onlySliderState,
    onlySpinnerState,
    onlyRoomTourState,
    onlyIframesState,
  };
};
